import React, { useState } from 'react';
import DataCollection from '../../shared/DataCollection';
import MessageCardList from './MessageCardList.js';
import { useTranslation } from 'react-i18next';
import './Messages.css';

const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd} ${hh}:${min}`;
};

export const Messages = (props) => {
  const { t } = useTranslation();
  const [tooltip, setTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

  const MsgCell = ({ text }) => (
    <div
      className="msg-cell"
      onMouseEnter={(e) => setTooltip({ visible: true, text, x: e.clientX, y: e.clientY })}
      onMouseMove={(e) => setTooltip(s => ({ ...s, x: e.clientX, y: e.clientY }))}
      onMouseLeave={() => setTooltip(s => ({ ...s, visible: false }))}
    >
      {text || '—'}
    </div>
  );

  const collection = 'messages'
  const columns = [
    {name: t("phone"),        selector: row => row.phone, sortable: true},
    {name: t("name"),         selector: row => row.name, sortable: true},
    {name: t("date"),         selector: row => row.date, sortable: true, format: row => formatDateTime(row.date)},
    {name: t("message_type"), selector: row => row.message_type, sortable: true},
    {name: t("direction"),    selector: row => row.direction, sortable: true},
    {name: t("raw_message"),  selector: row => row.raw_message, sortable: true, grow: 3,
      cell: row => <MsgCell text={row.raw_message} />},
  ];
  return (
    <>
      {tooltip.visible && (
        <div className="msg-tooltip" style={{ left: tooltip.x + 14, top: tooltip.y + 14 }}>
          {tooltip.text}
        </div>
      )}
      <DataCollection
        collection={collection}
        columns={columns}
        sortField={3}
        sortAsc={false}
        mobileComponent={(data) => (
          <MessageCardList data={data} />
        )}
      />
    </>
  );
}
export default Messages;
